(function ($) {
  'use strict';
  var $window = $(window);
  var widths = [29, 30, 32, 34, 38, 40, 41];
  
  /** @function
   * @name setRandomize
   * @description set random width for Masonry bricks
   */
  function setRandomize() {
    $('.masonry-brick').each(function (i, el) {
      var rand = widths[Math.floor(Math.random() * widths.length)];
      $(this).addClass('masonry-brick--' + rand);
    });
  }

  /** @function
   * @name initMasonry
   * @description inits the Masonry Lookbook
   */
  function initMasonry() {
    var $grid = $('#masonry');

    if ($grid.length) {
      if ($window.width() >= 990) {
        setRandomize();
      }
      $grid.packery({
        itemSelector: '.masonry-brick'
      });

      $grid.imagesLoaded().progress(function () {
        $grid.packery('layout');
      });
    }
  }

  /** @function
   * @name initLightGallery
   * @description inits the LightGallery for Masonry Lookbook
   */
  function initLightGallery() {
    var $grid = $('#masonry');
    if ($grid.length) {
      $grid.lightGallery({
        mode: 'lg-slide',
        thumbnail: true,
        selector: '.masonry-brick a',
        download: false,
        counter: false,
        speed: 840,
        backdropDuration: 300,
        easing: 'easeInQuad',
        startClass: 'lg-start'
      });
    }
  }


  $(document).ready(function () {
    initMasonry();
    initLightGallery();
  });

})(jQuery);
